import axios from "axios";
import React, { useState, useEffect } from "react";
import CreaJunta from "../Modals/crear/CreaAutoevaluacion/CreaJuntaDirectiva";
import Cookies from "universal-cookie";

function Titulo51SeccionA(props) {
  const cookies = new Cookies();
  const [list, setList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  useEffect(() => {
    obtenerLista();
  }, [props.idSolicitud]);

  const obtenerLista = () => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: `https://suadesarrollo.azurewebsites.net/api/ObtenerJuntaDirectivaPorSolicitudId?SolicitudId=${props.idSolicitud}`,
    })
      .then((response) => {
        setList(response.data || []);
      })
      .catch(console.log);
  };

  // 🔹 SE AGREGA REGISTRO SIN RECARGAR
  const onRegistroCreado = (nuevo) => {
    setList((prev) => [...prev, nuevo]);
  };

  // 🔹 ELIMINAR SIN RECARGAR
  const eliminarIntegrante = (id) => {
    if (!window.confirm("¿Estás seguro de eliminar este registro?")) return;

    axios({
      method: "delete",
      url: `https://suadesarrollo.azurewebsites.net/api/eliminarJuntaDirectivaPorId?Id=${id}`,
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      data: {
        TipoAccion: "Eliminación de registro Junta directiva",
        IdUsuario: cookies.get("id"),
      },
    })
      .then(() => {
        setList((prev) => prev.filter((item) => item.id !== id));
      })
      .catch(() => alert("No se pudo eliminar el registro"));
  };

  // 🔹 PAGINACIÓN
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = list.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(list.length / itemsPerPage);

  return (
    <div className="container-fluid">
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          <h6 className="m-0 font-weight-bold text-primary">
            Integrantes de Junta Directiva
          </h6>
        </div>

        <div className="card-body">
          {cookies.get("tipo_Usuario") === "2" &&
          window.location.href.includes("ProcesoAutoevaluacion") ? (
            <CreaJunta
              idSolicitud={props.idSolicitud}
              onRegistroCreado={onRegistroCreado}
            />
          ) : null}

          <hr />

          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Cargo</th>
                  <th>Profesión</th>
                  <th>Fecha Nombramiento</th>
                  <th>SolicitudId</th>
                  <th>Acción</th>
                </tr>
              </thead>
              <tbody>
                {currentItems.length > 0 ? (
                  currentItems.map((item) => (
                    <tr key={item.id || Math.random()}>
                      <td>{item.nombre}</td>
                      <td>{item.cargo}</td>
                      <td>{item.profesion}</td>
                      <td>{item.fechaNombramiento}</td>
                      <td>{item.solicitudId}</td>
                      <td>
                        {cookies.get("tipo_Usuario") === "2" ? (
                          <button
                            className="btn btn-danger btn-sm"
                            onClick={() => eliminarIntegrante(item.id)}
                          >
                            Eliminar
                          </button>
                        ) : null}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center">
                      No hay registros
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {totalPages > 1 && (
            <div className="pagination mt-3">
              {Array.from({ length: totalPages }, (_, i) => (
                <button
                  key={i}
                  className={`btn btn-sm mx-1 ${
                    currentPage === i + 1
                      ? "btn-primary"
                      : "btn-outline-primary"
                  }`}
                  onClick={() => setCurrentPage(i + 1)}
                >
                  {i + 1}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Titulo51SeccionA;
